import React, { Fragment } from 'react'
import {getSuperheadeingColor,getSupersubeingColor,getSubeingColor, convertTimeStampToDate } from './Reports.js';
import { indexOf } from 'lodash';
import "./Reports.css";

function DQI_Monthly({ dqi_params, thresholdColorsDqi }) {
    // function DQI_Monthly() {


  // const dqi_params =
  // {
  //       "Result": "OK",
  //       "data": {
  //         "businessUnit": [
  //           {
  //             "name": "RBU",
  //             "rigs": [
  //               {
  //                 "name": "HP-517",
  //                 "wells": [
  //                   {
  //                     "name": "MILL_IRON_STATE_CC18-765",
  //                     "logs": [
  //                       {
  //                         "name": "Baker - MWD",
  //                         "mnemonics": [
  //                           {
  //                             "name": "SEVZX",
  //                             "aspects": [
  //                               {
  //                                 "Channel_DQI": "50.0",
  //                                 "UoM": "gn",
  //                                 "Permissible_Trouble_Occurrences": "-",
  //                                 "Trouble_Time_Threshold": "-",
  //                                 "Expected_Max_Value": "10.0",
  //                                 "Expected_Min_Value": "1.0",
  //                                 "Expected_Interval": "1.0 to 10.0",
  //                                 "Required_Precision": "2.0",
  //                                 "Allowed_Data_Gap": "200.0",
  //                                 "Allowed_Staleness": "5.0(ms)",
  //                                 "Max_value_DQI": "10.0",
  //                                 "Min_value_DQI": "10.0",
  //                                 "Frequency_DQI": "10.0",
  //                                 "Precision_DQI": "10.0",
  //                                 "Data_gap_DQI": "10.0",
  //                                 "Staleness_DQI": "10.0",
  //                                 "DataCount_DQI": "10.0",
  //                                 "Latency_DQI": "10.0",
  //                                 "data": [
  //                                   {
  //                                     "Start_Index": "10083.999",
  //                                     "End_Index": "10283.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "10283.999",
  //                                     "End_Index": "10483.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "10483.999",
  //                                     "End_Index": "10683.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "10683.999",
  //                                     "End_Index": "10883.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "10883.999",
  //                                     "End_Index": "11083.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "11083.999",
  //                                     "End_Index": "11283.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "11283.999",
  //                                     "End_Index": "11483.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "11483.999",
  //                                     "End_Index": "11683.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "11683.999",
  //                                     "End_Index": "11883.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "11883.999",
  //                                     "End_Index": "12083.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "12083.999",
  //                                     "End_Index": "12283.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "12283.999",
  //                                     "End_Index": "12483.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "12483.999",
  //                                     "End_Index": "12683.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "12683.999",
  //                                     "End_Index": "12883.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "12883.999",
  //                                     "End_Index": "13083.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "13083.999",
  //                                     "End_Index": "13283.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "13283.999",
  //                                     "End_Index": "13483.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "13483.999",
  //                                     "End_Index": "13683.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "13683.999",
  //                                     "End_Index": "13883.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "13883.999",
  //                                     "End_Index": "14083.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "14083.999",
  //                                     "End_Index": "14283.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "14283.999",
  //                                     "End_Index": "14483.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "14483.999",
  //                                     "End_Index": "14683.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "14683.999",
  //                                     "End_Index": "14883.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "14883.999",
  //                                     "End_Index": "15083.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "15083.999",
  //                                     "End_Index": "15283.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "15283.999",
  //                                     "End_Index": "15483.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "15483.999",
  //                                     "End_Index": "15683.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "15683.999",
  //                                     "End_Index": "15883.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "15883.999",
  //                                     "End_Index": "16083.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "16083.999",
  //                                     "End_Index": "16283.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "16283.999",
  //                                     "End_Index": "16483.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "16483.999",
  //                                     "End_Index": "16683.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "16683.999",
  //                                     "End_Index": "16883.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "16883.999",
  //                                     "End_Index": "17083.999",
  //                                     "Result": "0"
  //                                   },
  //                                   {
  //                                     "Start_Index": "17083.999",
  //                                     "End_Index": "17283.999",
  //                                     "Result": "0"
  //                                   }
  //                                 ]
  //                               }
  //                             ]
  //                           },
  //                           {
  //                               "name": "VDEPTH",
  //                               "aspects": [
  //                                   {
  //                                       "Channel_DQI": "0.0",
  //                                       "UoM": "gn",
  //                                       "Permissible_Trouble_Occurrences": "-",
  //                                       "Trouble_Time_Threshold": "-",
  //                                       "Expected_Max_Value": "10.0",
  //                                       "Expected_Min_Value": "1.0",
  //                                       "Expected_Interval": "1.0 to 10.0",
  //                                       "Required_Precision": "2.0",
  //                                       "Allowed_Data_Gap": "200.0",
  //                                       "Allowed_Staleness": "5.0(ms)",
  //                                       "Max_value_DQI": "10.0",
  //                                       "Min_value_DQI": "10.0",
  //                                       "Frequency_DQI": "10.0",
  //                                       "Precision_DQI": "10.0",
  //                                       "Data_gap_DQI": "10.0",
  //                                       "Staleness_DQI": "10.0",
  //                                       "DataCount_DQI": "10.0",
  //                                       "Latency_DQI": "10.0",
  //                                       "data": [
  //                                           {
  //                                               "Start_Index": "10083.999",
  //                                               "End_Index": "10283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "10283.999",
  //                                               "End_Index": "10483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "10483.999",
  //                                               "End_Index": "10683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "10683.999",
  //                                               "End_Index": "10883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "1083.999",
  //                                               "End_Index": "1283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "10883.999",
  //                                               "End_Index": "11083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "11083.999",
  //                                               "End_Index": "11283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "11283.999",
  //                                               "End_Index": "11483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "11483.999",
  //                                               "End_Index": "11683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "11683.999",
  //                                               "End_Index": "11883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "11883.999",
  //                                               "End_Index": "12083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "12083.999",
  //                                               "End_Index": "12283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "12283.999",
  //                                               "End_Index": "12483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "12483.999",
  //                                               "End_Index": "12683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "12683.999",
  //                                               "End_Index": "12883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "1283.999",
  //                                               "End_Index": "1483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "12883.999",
  //                                               "End_Index": "13083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "13083.999",
  //                                               "End_Index": "13283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "13283.999",
  //                                               "End_Index": "13483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "13483.999",
  //                                               "End_Index": "13683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "13683.999",
  //                                               "End_Index": "13883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "13883.999",
  //                                               "End_Index": "14083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "14083.999",
  //                                               "End_Index": "14283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "14283.999",
  //                                               "End_Index": "14483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "14483.999",
  //                                               "End_Index": "14683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "14683.999",
  //                                               "End_Index": "14883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "1483.999",
  //                                               "End_Index": "1683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "14883.999",
  //                                               "End_Index": "15083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "15083.999",
  //                                               "End_Index": "15283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "15283.999",
  //                                               "End_Index": "15483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "15483.999",
  //                                               "End_Index": "15683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "15683.999",
  //                                               "End_Index": "15883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "15883.999",
  //                                               "End_Index": "16083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "16083.999",
  //                                               "End_Index": "16283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "16283.999",
  //                                               "End_Index": "16483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "16483.999",
  //                                               "End_Index": "16683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "16683.999",
  //                                               "End_Index": "16883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "1683.999",
  //                                               "End_Index": "1883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "16883.999",
  //                                               "End_Index": "17083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "17083.999",
  //                                               "End_Index": "17283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "1883.999",
  //                                               "End_Index": "2083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "2083.999",
  //                                               "End_Index": "2283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "2283.999",
  //                                               "End_Index": "2483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "2483.999",
  //                                               "End_Index": "2683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "2683.999",
  //                                               "End_Index": "2883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "283.999",
  //                                               "End_Index": "483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "2883.999",
  //                                               "End_Index": "3083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "3083.999",
  //                                               "End_Index": "3283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "3283.999",
  //                                               "End_Index": "3483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "3483.999",
  //                                               "End_Index": "3683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "3683.999",
  //                                               "End_Index": "3883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "3883.999",
  //                                               "End_Index": "4083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "4083.999",
  //                                               "End_Index": "4283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "4283.999",
  //                                               "End_Index": "4483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "4483.999",
  //                                               "End_Index": "4683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "4683.999",
  //                                               "End_Index": "4883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "483.999",
  //                                               "End_Index": "683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "4883.999",
  //                                               "End_Index": "5083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "5083.999",
  //                                               "End_Index": "5283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "5283.999",
  //                                               "End_Index": "5483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "5483.999",
  //                                               "End_Index": "5683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "5683.999",
  //                                               "End_Index": "5883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "5883.999",
  //                                               "End_Index": "6083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "6083.999",
  //                                               "End_Index": "6283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "6283.999",
  //                                               "End_Index": "6483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "6483.999",
  //                                               "End_Index": "6683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "6683.999",
  //                                               "End_Index": "6883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "683.999",
  //                                               "End_Index": "883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "6883.999",
  //                                               "End_Index": "7083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "7083.999",
  //                                               "End_Index": "7283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "7283.999",
  //                                               "End_Index": "7483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "7483.999",
  //                                               "End_Index": "7683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "7683.999",
  //                                               "End_Index": "7883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "7883.999",
  //                                               "End_Index": "8083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "8083.999",
  //                                               "End_Index": "8283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "8283.999",
  //                                               "End_Index": "8483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "83.999",
  //                                               "End_Index": "283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "8483.999",
  //                                               "End_Index": "8683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "8683.999",
  //                                               "End_Index": "8883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "883.999",
  //                                               "End_Index": "1083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "8883.999",
  //                                               "End_Index": "9083.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "9083.999",
  //                                               "End_Index": "9283.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "9283.999",
  //                                               "End_Index": "9483.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "9483.999",
  //                                               "End_Index": "9683.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "9683.999",
  //                                               "End_Index": "9883.999",
  //                                               "Result": "0"
  //                                           },
  //                                           {
  //                                               "Start_Index": "9883.999",
  //                                               "End_Index": "10083.999",
  //                                               "Result": "0"
  //                                           }
  //                                       ]
  //                                   }
  //                               ]
  //                           },
  //                         ],
  //                         "indexType": "DEPTHSERIES",
  //                         "startIndex": "10083.999",
  //                         "endIndex": "17283.999",
  //                         "windowLength": "200",
  //                         "dataProvider": "Baker Hughes",
  //                         "logDQIPercentage": "0.0",
  //                         "logColor":"red",
  //                       }
  //                     ],
  //                     "start_index": "1709803354855",
  //                     "end_index": "1709803387428",
  //                     "wellDQIPercentage": "0.0",
  //                     "wellColor":"yellow",
  //                   }
  //                 ]
  //               }
  //             ]
  //           },
  //           {
  //               "name": "LABU",
  //               "rigs": [
  //                 {
  //                   "name": "HP-517",
  //                   "wells": [
  //                     {
  //                       "name": "MILL_IRON_STATE_CC18-765",
  //                       "logs": [
  //                         {
  //                           "name": "Baker - MWD",
  //                           "mnemonics": [
  //                             {
  //                               "name": "SEVZX",
  //                               "aspects": [
  //                                 {
  //                                   "Channel_DQI": "25.0",
  //                                   "UoM": "gn",
  //                                   "Permissible_Trouble_Occurrences": "-",
  //                                   "Trouble_Time_Threshold": "-",
  //                                   "Expected_Max_Value": "10.0",
  //                                   "Expected_Min_Value": "1.0",
  //                                   "Expected_Interval": "1.0 to 10.0",
  //                                   "Required_Precision": "2.0",
  //                                   "Allowed_Data_Gap": "200.0",
  //                                   "Allowed_Staleness": "5.0(ms)",
  //                                   "Max_value_DQI": "10.0",
  //                                   "Min_value_DQI": "10.0",
  //                                   "Frequency_DQI": "10.0",
  //                                   "Precision_DQI": "10.0",
  //                                   "Data_gap_DQI": "10.0",
  //                                   "Staleness_DQI": "10.0",
  //                                   "DataCount_DQI": "10.0",
  //                                   "Latency_DQI": "10.0",
  //                                 }
  //                               ]
  //                             },
  //                             {
  //                                 "name": "VDEPTH",
  //                                 "aspects": [
  //                                     {
  //                                         "Channel_DQI": "0.0",
  //                                         "UoM": "gn",
  //                                         "Permissible_Trouble_Occurrences": "-",
  //                                         "Trouble_Time_Threshold": "-",
  //                                         "Expected_Max_Value": "10.0",
  //                                         "Expected_Min_Value": "1.0",
  //                                         "Expected_Interval": "1.0 to 10.0",
  //                                         "Required_Precision": "2.0",
  //                                         "Allowed_Data_Gap": "200.0",
  //                                         "Allowed_Staleness": "5.0(ms)",
  //                                         "Max_value_DQI": "10.0",
  //                                         "Min_value_DQI": "10.0",
  //                                         "Frequency_DQI": "10.0",
  //                                         "Precision_DQI": "10.0",
  //                                         "Data_gap_DQI": "10.0",
  //                                         "Staleness_DQI": "10.0",
  //                                         "DataCount_DQI": "10.0",
  //                                         "Latency_DQI": "10.0",
  //                                     }
  //                                 ]
  //                             },
  //                           ],
  //                           "indexType": "DEPTHSERIES",
  //                           "startIndex": "10083.999",
  //                           "endIndex": "17283.999",
  //                           "windowLength": "200",
  //                           "dataProvider": "Baker Hughes",
  //                           "logDQIPercentage": "0.0",
  //                           "logColor":"red",
  //                         }
  //                       ],
  //                       "start_index": "1709803354855",
  //                       "end_index": "1709803387428",
  //                       "wellDQIPercentage": "0.0",
  //                       "wellColor":"yellow",
  //                     },  {
  //                       "name": "MILL_IRON_STATE_CC18-767",
  //                       "logs": [
  //                         {
  //                           "name": "Baker - MWD",
  //                           "mnemonics": [
  //                             {
  //                               "name": "SEVZX",
  //                               "aspects": [
  //                                 {
  //                                   "Channel_DQI": "0.0",
  //                                   "UoM": "gn",
  //                                   "Permissible_Trouble_Occurrences": "-",
  //                                   "Trouble_Time_Threshold": "-",
  //                                   "Expected_Max_Value": "10.0",
  //                                   "Expected_Min_Value": "1.0",
  //                                   "Expected_Interval": "1.0 to 10.0",
  //                                   "Required_Precision": "2.0",
  //                                   "Allowed_Data_Gap": "200.0",
  //                                   "Allowed_Staleness": "5.0(ms)",
  //                                   "Max_value_DQI": "10.0",
  //                                   "Min_value_DQI": "10.0",
  //                                   "Frequency_DQI": "10.0",
  //                                   "Precision_DQI": "10.0",
  //                                   "Data_gap_DQI": "10.0",
  //                                   "Staleness_DQI": "10.0",
  //                                   "DataCount_DQI": "10.0",
  //                                   "Latency_DQI": "10.0",
  //                                 }
  //                               ]
  //                             },
  //                             {
  //                                 "name": "VDEPTH",
  //                                 "aspects": [
  //                                     {
  //                                         "Channel_DQI": "0.0",
  //                                         "UoM": "gn",
  //                                         "Permissible_Trouble_Occurrences": "-",
  //                                         "Trouble_Time_Threshold": "-",
  //                                         "Expected_Max_Value": "10.0",
  //                                         "Expected_Min_Value": "1.0",
  //                                         "Expected_Interval": "1.0 to 10.0",
  //                                         "Required_Precision": "2.0",
  //                                         "Allowed_Data_Gap": "200.0",
  //                                         "Allowed_Staleness": "5.0(ms)",
  //                                         "Max_value_DQI": "10.0",
  //                                         "Min_value_DQI": "10.0",
  //                                         "Frequency_DQI": "10.0",
  //                                         "Precision_DQI": "10.0",
  //                                         "Data_gap_DQI": "10.0",
  //                                         "Staleness_DQI": "10.0",
  //                                         "DataCount_DQI": "10.0",
  //                                         "Latency_DQI": "10.0",
  //                                     }
  //                                 ]
  //                             },
  //                           ],
  //                           "indexType": "DEPTHSERIES",
  //                           "startIndex": "10083.999",
  //                           "endIndex": "17283.999",
  //                           "windowLength": "200",
  //                           "dataProvider": "Baker Hughes",
  //                           "logDQIPercentage": "0.0",
  //                           "logColor":"red",
  //                         }
  //                       ],
  //                       "start_index": "1709803354855",
  //                       "end_index": "1709803387428",
  //                       "wellDQIPercentage": "0.0",
  //                       "wellColor":"yellow",
  //                     }
  //                   ]
  //                 }
  //               ]
  //             }
  //         ]
  //       },
  //   "customJs": [],
  //   "customCss": [],
  //   "hasfileContent": false
  // } 
  const getDQIColor = (value) => {
    const matchingColor = thresholdColorsDqi?.find(colors => value <= parseInt(colors.maxThresholdValue));
  
    if (matchingColor) {
        return { backgroundColor: matchingColor.backgroundColor, color: matchingColor.color };
    }
};

  
  if (dqi_params.data.businessUnit) {
    let totalLogs = 0;
    const indexLabels = ['Start Index', 'End Index'];

    // Calculate the total number of logs
    dqi_params.data.businessUnit.forEach(provider => {
      provider.rigs.forEach(rig => {
        rig.wells.forEach(well => {
          totalLogs += well.logs.length;
        });
      });
    });

    const truncateText = (text) => {
      if (text && text.includes('(')) {
          const openingBracketIndex = text.indexOf('(');
          const truncatedText = text.substring(0, openingBracketIndex) + '\n' + text.substring(openingBracketIndex);
          return truncatedText;
      }
      return text;
    };

    const filteredBusinessUnit = dqi_params.data.businessUnit
    .map(unit => ({
        ...unit,
        rigs: unit.rigs
            .map(rig => ({
                ...rig,
                wells: rig.wells.filter(well => well.logs.length > 0)
            }))
            .filter(rig => rig.wells.length > 0)
    }))
    .filter(unit => unit.rigs.length > 0);

  const totalProviderLogsforAll = filteredBusinessUnit.reduce((accProvider, provider) => {
    return accProvider + provider.rigs.reduce((accRig, rig) => {
      return accRig + rig.wells.reduce((accWell, well) => {
        return accWell + well.logs.length;
      }, 0);
    }, 0);
  }, 0);
  

  
  
    return (
      <Fragment>
             {
              (totalProviderLogsforAll !== 0 && filteredBusinessUnit.length > 0 )?
              <>
        <table className="tree-view">
          <thead>
            <tr><th colSpan={11} style={getSuperheadeingColor()}><b>Summary</b></th></tr>
            <tr style={getSubeingColor()} >
              <th className='forRight'><b>Business Unit</b></th>
              <th className='forRight'><b>Rig</b></th>
              <th className='forRight'><b>Well</b></th>
              <th className='forRight'><b>Log</b></th>
              <th className='forRight'><b>Index Type</b></th>
              <th className='forCenter'><b>Start Index</b></th>
              <th className='forCenter'><b>End Index</b></th>
              {/* <th><b>Window Length</b></th> */}
              {/* <th><b>Data Provider</b></th> */}
              <th className='forCenter'><b>Log DQI (%)</b></th>
              <th className='forCenter'><b>Well DQI (%)</b></th>
            </tr>
          </thead>
          <tbody>
       

               { filteredBusinessUnit.map(provider => {
                  let totalProviderLogs = provider.rigs.reduce((acc, rig) => {
                    return acc + rig.wells.reduce((accWell, well) => {
                      return accWell + well.logs.length;
                    }, 0);
                  }, 0);

                  return provider.rigs.map((rig, rigIndex) => {
                    let totalRigLogs = rig.wells.reduce((acc, well) => acc + well.logs.length, 0);
                    return rig.wells.map((well, wellIndex) => (
                      well.logs.map((log, logIndex) => (
                        <tr key={`${provider.name}-${rig.name}-${well.name}-${log.name}`}>
                          {(rigIndex === 0 && wellIndex === 0 && logIndex === 0) && (
                            <td rowSpan={totalProviderLogs} className='forRight' >{provider.name}</td>
                          )}
                          {(wellIndex === 0 && logIndex === 0) && (
                            <td className='forRight' rowSpan={totalRigLogs} >{rig.name}</td>
                          )}
                          {(logIndex === 0) && <td className='forRight' rowSpan={well.logs.length}>{well.name}</td>}
                          <td className='forRight' >{log.name || "-"}</td>
                          <td className='forRight'>{log.indexType || "-"}</td>
                          <td className='forRight'>{log.indexType === "TIMESERIES" && log.startIndex !== "NOT CALCULATING" ? convertTimeStampToDate(log.startIndex) : log.startIndex || "-"}</td>
                          <td className='forRight'>{log.indexType === "TIMESERIES" && log.endIndex !== "NOT CALCULATING" ? convertTimeStampToDate(log.endIndex) : log.endIndex || "-"}</td>
                          {/* <td>{log.windowLength || "-"}</td> */}
                          {/* <td>{log.dataProvider || "-"}</td> */}
                          <td className='forCenter'style={getDQIColor(log.logDQIPercentage)}>{log.logDQIPercentage || "-"}</td>
                          {(logIndex === 0) && <td className='forCenter'rowSpan={well.logs.length} style={getDQIColor(well.wellDQIPercentage)}>{well.wellDQIPercentage || "-"}</td>}
                        </tr>
                      ))
                    ))
                  })
                })} 
          </tbody>
        </table>
        <div style={{ width: "100%", paddingRight: "20px" }}>
        <div style={{ marginTop: "35px" }}>
                    <table className="tree-view">
                      <tr>
                        <td style={getSuperheadeingColor()}><b> Detail</b></td>
                      </tr>
                    </table>
                    {/* <table>
                      <tr>
                        <th><b> Rig</b></th>
                        <th><b> Well</b></th>
                        <th><b> Business Unit</b></th>
                      </tr>
                      <tr>
                        <td>{rig.name}</td>
                        <td>{well.name}</td>
                        <td>{provider.name}</td>
                      </tr>
                    </table> */}
                  </div>
          {filteredBusinessUnit.map(provider => (
            provider.rigs.map(rig => (
              rig.wells.map(well => (
                <div key={`${provider.name}-${rig.name}-${well.name}`} >
                 
                  {well?.logs?.map((log, index) => (
                    <div key={`${provider?.name}-${rig?.name}-${well?.name}-${log?.name}`} style={{marginBottom:"35px"}} >
                      {/* Section for Log */}
                      {log?.mnemonics?.[0]?.name && (
                        // <table>
                        //   <tr>
                        //     <td>
                        //       <b>Log: {log.name}</b>
                        //     </td>
                        //   </tr>
                        // </table>
                        <table className="tree-view">
                        <tr style={getSupersubeingColor()}>
                          <th className='forRight'><b>Business Unit</b></th>
                          <th className='forRight'><b>Rig</b></th>
                          <th className='forRight'><b>Well</b></th>
                          <th className='forRight'><b>Data Source</b></th>
                          <th className='forRight'><b>DQI</b></th>
                         
                        </tr>
                        <tr >
                          <td className='forRight'>{provider.name}</td>
                          <td className='forRight'>{rig.name}</td>
                          <td className='forRight'>{well.name}</td>
                          <td className='forRight'>{log.name}</td>
                          <td className='forRight' style={getDQIColor(log.logDQIPercentage)}>{log.logDQIPercentage}</td>
                        </tr>
                      </table>
                      )}
                      {log?.mnemonics?.[0]?.name && (
                        <Fragment>
                          <table className="mnemonics-view">
                            <thead>
                              <tr style={getSubeingColor()}>

                                <th className='forCenter'><b>Channel</b></th>
                                <th className='forCenter'><b>DQI</b></th>
                                <th className='forCenter'><b>UoM</b></th>
                                {/* <th className='forCenter'><b>Permissible Trouble Occurrences</b></th>
                                <th className='forCenter'><b>Trouble Threshold</b></th> */}
                                <th className='forCenter'><b>Expected Max Value</b></th>
                                <th className='forCenter'><b>Expected Min Value</b></th>
                                <th className='forCenter'><b>Frequency Interval</b></th>
                                <th className='forCenter'><b>Required Precision</b></th>
                                <th className='forCenter'><b>Allowed Data Gap</b></th>
                                <th className='forCenter'><b>Allowed Staleness</b></th>
                                <th className='forCenter'><b>Max Value DQI</b></th>
                                <th className='forCenter'><b>Min Value DQI</b></th>
                                <th className='forCenter'><b>Frequency DQI</b></th>
                                <th className='forCenter'><b>Precision DQI</b></th>
                                <th className='forCenter'><b>Data Gap DQI</b></th>
                                <th className='forCenter'><b>Staleness DQI</b></th>
                                <th className='forCenter'><b>DataCount DQI</b></th>
                                <th className='forCenter'><b>Latency DQI</b></th>
                               
                              </tr> 
                            </thead>  
                            <tbody>
                              {log.mnemonics.map(mnemonic => (
                                <tr key={`${provider.name}-${rig.name}-${well.name}-${log.name}-${mnemonic.name}`}>
                                  <td className='forRight'><b>{truncateText(mnemonic.name === "" ? "-" : mnemonic.name === 0 ? 0 : mnemonic.name)}</b></td>
                                  <td className='forCenter'style={getDQIColor(mnemonic?.aspects?.[0].Channel_DQI)}>{truncateText(mnemonic?.aspects?.[0].Channel_DQI === undefined || mnemonic?.aspects?.[0].Channel_DQI === "" ? "-" : mnemonic?.aspects?.[0].Channel_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Channel_DQI)}</td>
                                  <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].UoM === "" ? "-" : mnemonic?.aspects?.[0].UoM === 0 ? 0 : mnemonic?.aspects?.[0].UoM)}</td>
                                  {/* <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences === "" ? "-" : mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences === 0 ? 0 : mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences)}</td>
                                  <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Trouble_Time_Threshold === "" ? "-" : mnemonic?.aspects?.[0].Trouble_Time_Threshold === 0 ? 0 : mnemonic?.aspects?.[0].Trouble_Time_Threshold)}</td> */}
                                  <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Expected_Max_Value === "" ? "-" : mnemonic?.aspects?.[0].Expected_Max_Value === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Max_Value)}</td>
                                  <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Expected_Min_Value === "" ? "-" : mnemonic?.aspects?.[0].Expected_Min_Value === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Min_Value)}</td>
                                  <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Expected_Interval === "" ? "-" : mnemonic?.aspects?.[0].Expected_Interval === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Interval)}</td>
                                  <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Required_Precision === "" ? "-" : mnemonic?.aspects?.[0].Required_Precision === 0 ? 0 : mnemonic?.aspects?.[0].Required_Precision)}</td>
                                  <td className='forRight'>{truncateText(mnemonic?.aspects?.[0].Allowed_Data_Gap === "" ? "-" : mnemonic?.aspects?.[0].Allowed_Data_Gap === 0 ? 0 : mnemonic?.aspects?.[0].Allowed_Data_Gap)}</td>
                                  <td className='forRight'>{truncateText(mnemonic?.aspects?.[0].Allowed_Staleness === "" ? "-" : mnemonic?.aspects?.[0].Allowed_Staleness === 0 ? 0 : mnemonic?.aspects?.[0].Allowed_Staleness)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Max_value_DQI)}>{truncateText(mnemonic?.aspects?.[0].Max_value_DQI === "" ? "-" : mnemonic?.aspects?.[0].Max_value_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Max_value_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Min_value_DQI)}>{truncateText(mnemonic?.aspects?.[0].Min_value_DQI === "" ? "-" : mnemonic?.aspects?.[0].Min_value_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Min_value_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Frequency_DQI)}>{truncateText(mnemonic?.aspects?.[0].Frequency_DQI === "" ? "-" : mnemonic?.aspects?.[0].Frequency_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Frequency_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Precision_DQI)}>{truncateText(mnemonic?.aspects?.[0].Precision_DQI === "" ? "-" : mnemonic?.aspects?.[0].Precision_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Precision_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Data_gap_DQI)}>{truncateText(mnemonic?.aspects?.[0].Data_gap_DQI === "" ? "-" : mnemonic?.aspects?.[0].Data_gap_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Data_gap_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Staleness_DQI)}>{truncateText(mnemonic?.aspects?.[0].Staleness_DQI === "" ? "-" : mnemonic?.aspects?.[0].Staleness_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Staleness_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].DataCount_DQI)}>{truncateText(mnemonic?.aspects?.[0].DataCount_DQI === "" ? "-" : mnemonic?.aspects?.[0].DataCount_DQI === 0 ? 0 : mnemonic?.aspects?.[0].DataCount_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Latency_DQI)}>{truncateText(mnemonic?.aspects?.[0].Latency_DQI === "" ? "-" : mnemonic?.aspects?.[0].Latency_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Latency_DQI)}</td>
                                 
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          {/* {log?.mnemonics[0]?.aspects[0].data[0] && (
                            <div style={{ marginTop: "10px", marginBottom: "35px" }}><b>Data Quality History</b>

                              <table >

                                <thead>
                                  <tr>
                                    <th colSpan={2}><b>Mnemonic</b></th>
                                    {log.mnemonics.map(mnemonic => (
                                      <th><b>{mnemonic.name === "" ? "-" : mnemonic.name === 0 ? 0 : mnemonic.name}</b></th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td colSpan={2}><b>Channel DQI</b></td>
                                    {log.mnemonics.map(mnemonic => (
                                      <td style={getDQIColor(mnemonic?.aspects?.[0].Channel_DQI)}>{mnemonic?.aspects?.[0].Channel_DQI === "" ? "-" : mnemonic?.aspects?.[0].Channel_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Channel_DQI}</td>
                                    ))}
                                  </tr>
                                  <tr>
                                    <td><b>Start Index</b></td>
                                    <td><b>End Index</b></td>
                                    <td colSpan={log?.mnemonics.length}></td>
                                  </tr>
                           
                                  {log.indexType === "TIMESERIES" ?
                                    log?.mnemonics[index]?.aspects[0]?.data?.map((data, index) => (
                                      <tr key={index}>
                                        <td>{convertTimeStampToDate(data.Start_Index)}</td>
                                        <td>{convertTimeStampToDate(data.End_Index)}</td>
                                        {log?.mnemonics?.map((mnemonic, mnemonicIndex) => (
                                          <td key={`${index}-${mnemonicIndex}`}>
                                            {mnemonic?.aspects[0]?.data[index]?.Result}
                                          </td>
                                        ))}
                                      </tr>
                                    )) : log?.mnemonics[index]?.aspects[0]?.data?.map((data, index) => (
                                      <tr key={index}>
                                        <td>{data.Start_Index}</td>
                                        <td>{data.End_Index}</td>
                                        {log?.mnemonics?.map((mnemonic, mnemonicIndex) => (
                                          <td key={`${index}-${mnemonicIndex}`}>
                                            {mnemonic?.aspects[0]?.data[index]?.Result}
                                          </td>
                                        ))}
                                      </tr>
                                    ))
                                  }
                                </tbody>
                              </table>
                            </div>
                          )} */}
                        </Fragment>
                      )}
                    </div>
                  ))}
                </div>
              ))
            ))
          ))}
        </div></>
        : <p style={{ textAlign: "center", fontWeight:"700" }}>Monthly Data not Found</p>}
      </Fragment>
    );
  }
  else {
    return "No Monthly Data Found";
  }
}
export default DQI_Monthly;